<template>
    <button class="text-light btn-header h-100 px-2 mr-1" @click="$emit('click')" v-tooltip.bottom="tip">
        <slot></slot>
    </button>
</template>

<script>
export default {
  name: 'HeaderButton',
  props: ['tip']
}
</script>

<style lang="scss">
    .btn-header {
        font-size: 1em;
        border: 0;
        margin-top: -1px;
        transition: 0.2s ease-out background;
    }
</style>
